import React from 'react';

function AddFundstoVA() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>Add funds to VA</h1>
               <hr />
               <p class="mt-30">
                  To add funds to your virtual account (VA), follow these simple steps:
               </p>
               <ol>
                  <li>Got to your Bank’s Net Banking portal/app. This should be the account which is whitelisted with Safexpay.</li>
                  <li>Add your Virtual Account details as Beneficiary (under Other Banks section). You can find your Virtual Account details on the dashboard.</li>
                  <li>Transfer the funds to the VA (added Beneficary) only via IMPS/NEFT/RTGS payment type.</li>
                  <li>The transferred amount shall be reflected in your Virtual Account within 30 mins. (NEFT – as per settlement cycle)</li>
               </ol>
               <img src={process.env.PUBLIC_URL + '/images/Flowchart.jpg'} alt="logo" />
              
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
      
      
   </div>
</div>
)
}
export default AddFundstoVA